/*
 * Copyright (c) 2025 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { RouteId } from '../router/routes';
import { AppAbility } from './ability';
import { ScreenPermit } from './permits';

export const SCREEN_PERMIT_BY_ROUTE_ID: { [key in RouteId]?: ScreenPermit } = {
    [RouteId.Main]: 'DOCUMENT_PICTURE_SCREEN',
    [RouteId.SystemSettingsInfo]: 'USER_SETTINGS_INFO_SCREEN',
    [RouteId.SystemSettingsSecurity]: 'USER_SETTINGS_SECURITY_SCREEN',
    [RouteId.SystemAdminUsers]: 'ADMIN_USERS_LIST_SCREEN',
    [RouteId.Home]: 'INSPECTOR_HOME_SCREEN',
    [RouteId.HomeTaxpayer]: 'TAXPAYER_HOME_SCREEN',
    [RouteId.HomeOperator]: 'OPERATOR_HOME_SCREEN',
    [RouteId.InfographicFin]: 'INFOGRAPHICS_FIN_SCREEN',
    [RouteId.InfographicTech]: 'INFOGRAPHICS_TECH_SCREEN',
    [RouteId.InfographicRegional]: 'REGIONAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    [RouteId.InfographicCentral]: 'CENTRAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    [RouteId.Statistics]: 'STATISTICS_SCREEN',
    [RouteId.AlertsList]: 'ALERTS_LIST_SCREEN',
    [RouteId.AlertCard]: 'ALERT_DETAILS_SCREEN',
    [RouteId.AlertsSettings]: 'ALERTS_SETTINGS_SCREEN',
    [RouteId.AlertLogs]: 'ALERT_EXECUTION_LOGS_SCREEN',
    [RouteId.AlertRules]: 'ALERT_RULES_SCREEN',
    [RouteId.Reports]: 'REPORTS_SCREEN',
    [RouteId.MapStores]: 'STORES_MAP_SCREEN',
    [RouteId.MapCashboxes]: 'CASHBOXES_MAP_SCREEN',
    [RouteId.RegistryOperatorsList]: 'OPERATORS_LIST_SCREEN',
    [RouteId.RegistryOperatorCard]: 'OPERATOR_CARD_SCREEN',
    [RouteId.RegistryCompaniesList]: 'COMPANIES_LIST_SCREEN',
    [RouteId.RegistryCompanyCard]: 'COMPANY_CARD_SCREEN',
    [RouteId.RegistryStoresList]: 'STORES_LIST_SCREEN',
    [RouteId.RegistryStoreCard]: 'STORE_CARD_SCREEN',
    [RouteId.RegistryCashboxesList]: 'CASHBOXES_LIST_SCREEN',
    [RouteId.RegistryCashboxCard]: 'CASHBOX_CARD_SCREEN',
    [RouteId.RegistryDocumentsList]: 'DOCUMENTS_LIST_SCREEN',
    [RouteId.RegistryDocumentCard]: 'DOCUMENT_CARD_SCREEN',
    [RouteId.RegistryDocumentCardPict]: 'DOCUMENT_CARD_PICT_SCREEN',
    [RouteId.RegistryDevicesList]: 'DEVICES_LIST_SCREEN',
    [RouteId.RegistryDeviceCard]: 'DEVICE_CARD_SCREEN',
    [RouteId.RegistryCashRegisterModelsList]: 'CASHREGISTER_MODELS_LIST_SCREEN',
    [RouteId.RegistryCashRegisterModelCard]: 'CASHREGISTER_MODEL_CARD_SCREEN',
    [RouteId.RegistryCashRegistersList]: 'CASHREGISTERS_LIST_SCREEN',
    [RouteId.RegistryCashRegisterCard]: 'CASHREGISTER_CARD_SCREEN',
    [RouteId.Service]: 'SERVICE_SCREEN',
};

export const isNavigationAllowed = (ability: AppAbility, routeId: RouteId): boolean => {
    if (!ability || ability.rules.length === 0) return false;
    const permit = SCREEN_PERMIT_BY_ROUTE_ID[routeId];
    return permit && ability.can('viewScreen', permit);
};
